import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
export default function AdminUpdates() {
	useDocumentTitle("Admin Updates");
	return (
		<div className="p-4">
			<h1 className="text-lg mb-6">Updates</h1>
			<div className="space-y-4">
				<div className="h-32 rounded-lg bg-muted animate-pulse" />
				<div className="h-32 rounded-lg bg-muted animate-pulse" />
			</div>
		</div>
	);
}
